
export const calculateTranslateXPosition = (windowWidth, container, fullscreenScale) => {
	const { left, width } = container.getBoundingClientRect();
	const { offsetWidth } = container;
	const scaledDifference = (offsetWidth - width) / 2;
	const centerOfContainer = left - scaledDifference + (offsetWidth / 2);
	const centerOfScreen = windowWidth / 2;
	const translateXPostion = (centerOfScreen - centerOfContainer) / fullscreenScale;
	return translateXPostion;
};

export const calculateTranslateYPosition = (windowHeight, container, fullscreenScale) => {
	const factor = (fullscreenScale * 2);
	const { height, top } = container.getBoundingClientRect();
	const centerOfScreen = windowHeight / factor;
	const translateYPostion = (centerOfScreen - height / factor) - top / fullscreenScale;
	return translateYPostion;
};

export const calculatePadding = (contentContainer, fullscreenScale) => {
	let { padding } = getComputedStyle(contentContainer);
	padding = padding.replace('px', '');
	return Math.ceil(padding / fullscreenScale);
};



// WEBPACK FOOTER //
// ./src/ui/interaction/children/animatedVisualizations/calculateTranslate.js